var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0H6.875C3.07804 0 0 3.07804 0 6.875V37.125C0 40.922 3.07804 44 6.875 44H37.125C40.922 44 44 40.922 44 37.125V6.875C44 3.07804 40.922 0 37.125 0Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.125C32.175 15.5375 31.35 15.675 30.3875 15.8125C31.35 15.2625 32.0375 14.4375 32.3125 13.3375C31.4875 13.8875 30.525 14.1625 29.425 14.4375C28.6 13.6125 27.3625 13.0625 26.125 13.0625C23.2375 13.0625 21.0375 15.8125 21.725 18.5625C18.0125 18.425 14.7125 16.6375 12.375 13.8875C11.1375 15.95 11.825 18.5625 13.75 19.9375C13.0625 19.9375 12.375 19.6625 11.6875 19.3875C11.6875 21.45 13.2 23.375 15.2625 23.925C14.575 24.0625 13.8875 24.2 13.2 24.0625C13.75 25.85 15.4 27.225 17.4625 27.225C15.8125 28.4625 13.3375 29.15 11 28.875C13.0625 30.1125 15.4 30.9375 17.875 30.9375C26.2625 30.9375 30.9375 23.925 30.6625 17.4625C31.625 16.9125 32.45 16.0875 33 15.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1bc6de9b166f30c3c4aadb7582160cbe.svg";
export { ForwardRef as ReactComponent };